import { makePostRequest } from '../apiHelpers';
import { toastr } from 'react-redux-toastr';

export const sendLeasingCompanyEmail = (agreementHeaderId, leasingCompanyId) => {
    makePostRequest(['agreement', 'send-leasing-company-email', agreementHeaderId, leasingCompanyId])
        .then(() => toastr.success('Send Leasing Company Email', `Success`))
        .catch(error => toastr.error('Send Leasing Company Email', `Response ${error.message}`));
};
